<div class="icon__wrapper" [ngClass]="bgCssClass()">
  <span class="icon__icon" [ngClass]="iconCssClass()">{{ label() }}</span>
</div>
